import * as React from "react";
import * as MapboxGl from "mapbox-gl";
import { MapContext } from "react-mapbox-gl";

export interface Props {
  layerId: string;
  onHover?: (f: any) => void;
}

let _hoveredFeature: MapboxGl.MapboxGeoJSONFeature | null = null;

export default function HoverFeatures({ layerId, onHover }: Props) {
  const map = React.useContext(MapContext);

  const setHoverState = React.useCallback(
    (f: MapboxGl.MapboxGeoJSONFeature, b: boolean) => {
      if (map) {
        map.setFeatureState(f, { hover: b });
      }
    },
    [map]
  );

  const onStyleDataChange = () => {
    if (_hoveredFeature !== null) {
      setHoverState(_hoveredFeature, true);
    }
  };

  const mouseMove = (e: MapboxGl.MapMouseEvent) => {
    let features = e.target.queryRenderedFeatures(e.point, { layers: [layerId] });
    if (_hoveredFeature !== null) {
      setHoverState(_hoveredFeature, false);
    }
    if (features && features.length) {
      let feature = features[0];
      e.target.getCanvas().style.cursor = "pointer";
      setHoverState(feature, true);
      if (onHover && (_hoveredFeature === null || feature.id !== _hoveredFeature.id)) onHover(feature);
      _hoveredFeature = feature;
    }
  };

  const mouseLeave = (e: MapboxGl.MapMouseEvent) => {
    e.target.getCanvas().style.cursor = "";
    if (_hoveredFeature !== null) {
      setHoverState(_hoveredFeature, false);
      if (onHover) onHover(null);
      _hoveredFeature = null;
    }
  };

  React.useEffect(() => {
    if (map) {
      map.on("styledata", onStyleDataChange);
      map.on("mousemove", layerId, mouseMove);
      map.on("mouseleave", layerId, mouseLeave);
    }
    return () => {
      if (map) {
        map.off("styledata", onStyleDataChange);
        map.off("mousemove", layerId, mouseMove);
        map.off("mouseleave", layerId, mouseLeave);
      }
    };
  }, [map]);

  return null;
}
